export default __webpack_public_path__ + "bf179a22347045e535be5e062c3aae77.png";